import { Component, DestroyRef, inject } from '@angular/core';
import { PopoverService } from '@app/storybook/services/popover/popover.service';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { finalize } from 'rxjs';
import { OrderEditingService } from './order-editing.service';
import { ShopService } from '@app/services/shops/shop.service';
@Component({
  selector: 'order-editing',
  standalone: false,
  templateUrl: './order-editing.component.html',
  styleUrl: './order-editing.component.scss',
})
export class OrderEditingComponent {
  saveLoading: boolean;

  isOpen = false;
  destroyRef = inject(DestroyRef);
  constructor(
    public orderEditingService: OrderEditingService,
    private toastService: ToastService,
    public popoverService: PopoverService,
    public shopService: ShopService,
  ) {}

  onCancel() {
    this.orderEditingService.resetForm();
  }

  onSave() {
    this.saveLoading = true;
    this.orderEditingService
      .saveConfig$()
      .pipe(
        finalize(() => {
          this.saveLoading = false;
        }),
      )
      .subscribe({
        next: () => {
          this.toastService.showToast({
            message: 'Order editing config saved',
            mode: 'success',
          });
        },
        error: () => {
          this.toastService.showToast({
            message: 'Failed to save order editing config',
            mode: 'danger',
          });
        },
      });
  }
}
